import { AxiosProgressEvent } from "axios";
import apiConfig from "constants/apiConfig"
import { SavedAddress } from "types";
import axiosClient from "utils/axiosClient"

export const fetchAddress = async (addressUUID: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_ADDRESS.url.replace('<addressUUID>', addressUUID));
    return response.data.address as SavedAddress;
}

export const fetchCollaborationPermalinkFile = async (
    agencyId: string,
    campaignId: string,
    influencerId: string,
    permalink: string,
    action: string | null = null,
    onDownloadProgress?: ((progressEvent: AxiosProgressEvent) => void)
) => {
    const isDownload = action === 'download';

    const response = await axiosClient.post(
        apiConfig.FETCH_COLLABORATION_PERMALINK_FILE.url.replace('<campaignId>', campaignId).replace('<agencyId>', agencyId).replace('<influencerId>', influencerId),
        { permalink, ...(isDownload ? { action } : {}) },
        isDownload ? { responseType: 'blob', onDownloadProgress } : undefined
    );

    return isDownload ? response.data : response.data;
};